import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FormBuilderService} from '../form-builder/form-builder.service';
import {cfgDForm, cfgDFormVersion} from '../form-builder/form-builder-model';

@Component({
    selector: 'app-form-builder-open-form',
    templateUrl: './form-builder-open-form.component.html',
    styleUrls: ['./form-builder-open-form.component.scss']
})
export class FormBuilderOpenFormComponent implements OnInit {

    constructor(

        private fbservice: FormBuilderService,

        public dialogRef: MatDialogRef<FormBuilderOpenFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,

    ) {}

    forms: cfgDForm[] = [];


    selectedForm: cfgDForm;
    formVersions: cfgDFormVersion[] = [];
    selectedVersion: cfgDFormVersion;
    selectedFormKeys: any[] = [];
    selectedFormVersionKeys: any[] = [];



    ngOnInit() {
        this.loadFormsList(false);

    }
    loadFormsList(isNew: boolean = false)  {
        // console.log ('init popup open form');
        this.fbservice.getListOfForms('ALL').subscribe(res => {

            this.forms = res;

            if (!isNew) {
                this.selectedForm = this.forms[0];

            }
            this.selectedFormKeys = [];
            this.selectedFormKeys.push(this.selectedForm.DFormId);

        });




    }

    onFormSelectionChanged(e)
    {
        this.selectedForm = e.addedItems[0];

        this.fbservice.getCfgDFormVersionList(this.selectedForm.DFormId).subscribe(res => {
            this.formVersions = res;
            this.selectedVersion = this.formVersions[0];
            this.selectedFormVersionKeys = [];
            this.selectedFormVersionKeys.push(this.selectedVersion.DFormVersionId);

        });



    }

    onAddFormClick() {

        this.fbservice.creteNewCfgDForm().subscribe(res => {
            this.selectedForm = res;


            this.loadFormsList(true);



        });




    }

    onDeleteFormClick() {
      this.fbservice.deleteCfgDForm(this.selectedForm.DFormId).subscribe(res=>{

        this.loadFormsList(false);

      });


    }

    onAddFormVersionClick() {




    }
    onDuplicateFormClick()  {


    }

    onFormVersionSelectClick()  {

        // close this and return current form
        let ret =  { selectedForm: this.selectedForm, selectedVersion: this.selectedVersion };

        this.dialogRef.close( ret);


    }
  onFormVersionCancelClick() {
    this.dialogRef.close( "X" );

  }







}
